import { combineReducers } from 'redux'
import googlePhotos from './googlePhotos'

export default combineReducers({
  googlePhotos,
});
